import { Controller } from "@hotwired/stimulus"
import { matches } from "../lib/search_words"

// Filtrerer en liste af medlemmer i browseren, mens der skrives. Hver linje
// bærer sin søgetekst i data-text. Matcher som SearchWords på serveren: hvert
// ord skal stå et sted i teksten, i vilkårlig rækkefølge.
//
// En skjult linje bliver i formularen, så et flueben, der er sat, bliver ved
// med at være sat, når man søger på en anden.
export default class extends Controller {
  static targets = ["query", "item", "status"]

  filter() {
    const query = this.queryTarget.value.trim()
    let shown = 0

    this.itemTargets.forEach((item) => {
      const visible = query === "" || matches(item.dataset.text, query)
      item.hidden = !visible
      if (visible) shown++
    })

    this.statusTarget.textContent = this.statusText(query, shown)
  }

  // Enter i søgefeltet må ikke gemme formularen.
  stay(event) {
    event.preventDefault()
  }

  statusText(query, shown) {
    if (query === "") return "Skriv en del af navnet eller byen."
    if (shown === 0) return "Ingen medlemmer passer på det. Prøv med en del af navnet."
    return shown === 1 ? "Viser 1 medlem." : `Viser ${shown} medlemmer.`
  }
}
